import { useEffect, useRef, useState } from "react";
import { renderWarpedArea, type AreaShape, type AreaFit, type AreaWarp } from "../../lib/area-shape";

type Area = { x: number; y: number; w: number; h: number; rotation?: number; shape?: AreaShape; fit?: AreaFit; warp?: AreaWarp | null };

/**
 * Kucuk onizlemelerde carpitilmis alan (perspektif/silindir): tasarim Studio ve
 * sunucu render'iyla ayni esleme ile basilir — her yerde ayni gorunsun.
 * Kapsayici gorselin oraninda olmali; konum yuzde ile verilir.
 */
export function WarpedAreaImage({ area, src, imageW, imageH, opacity = 1 }: { area: Area; src: string; imageW: number; imageH: number; opacity?: number }) {
  const ref = useRef<HTMLCanvasElement>(null);
  const [box, setBox] = useState<{ left: number; top: number; width: number; height: number } | null>(null);
  const key = JSON.stringify(area);
  useEffect(() => {
    let alive = true;
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      if (!alive || !ref.current) return;
      // Onizleme kucuk: ~400px olcekte calismak yeterli ve hizli
      const k = Math.min(1, 400 / Math.max(imageW, imageH));
      const warp = area.warp?.type === "perspective"
        ? { ...area.warp, corners: area.warp.corners.map(([dx, dy]) => [dx * k, dy * k] as [number, number]) }
        : area.warp;
      const r = renderWarpedArea(img, { ...area, x: area.x * k, y: area.y * k, w: area.w * k, h: area.h * k, warp });
      const c = ref.current;
      c.width = r.canvas.width; c.height = r.canvas.height;
      c.getContext("2d")!.drawImage(r.canvas, 0, 0);
      setBox({ left: r.left / k, top: r.top / k, width: r.canvas.width / k, height: r.canvas.height / k });
    };
    img.src = src;
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, src, imageW, imageH]);
  return (
    <canvas ref={ref} className="pointer-events-none absolute" style={box ? {
      left: `${(box.left / imageW) * 100}%`, top: `${(box.top / imageH) * 100}%`,
      width: `${(box.width / imageW) * 100}%`, height: `${(box.height / imageH) * 100}%`, opacity,
    } : { display: "none" }} />
  );
}
